module.exports = __webpack_public_path__ + "img/partner.5b69ed20.png";